export default "__VITE_ASSET__CPncZliv__"